import { render, staticRenderFns } from "./k-tabs.vue?vue&type=template&id=574a3b32&"
import script from "./k-tabs.vue?vue&type=script&lang=ts&"
export * from "./k-tabs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports